import UtilServices from "@services/UtilServices";
import "./Input.scss";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";

export default function Input({
  id = "",
  type = "text",
  placeholder = "",
  value = "",
  disabled = false,
  title = "",
  onChange = () => null,
  className = "",
  theme = "1",
  style = {},
  mask = "",
  maxLength = null,
  defaultValue = "",
  icon = "",
  name = "",
  //Erros
  register = null,
  errors = null,
  required = true,
  setValue = null,
  //Button
  button = false,
  dflex = true,
  iconButton = "pesquisar",
  titleButton = "",
  typeButton = "button",
  onClickButton = () => null,
  gapButton = "10px",
  disabledButton = false,
  //ToolTip
  tooltip = false,
  tooltipId = "",
  tooltipIcon = <i className="fa-solid fa-hexagon-exclamation"></i>,
  tooltipDescricao = "",
  tooltipIconColor = "#ff7575c9",
  registerProps = {},
}) {
  let inputClassName = `input-input ${className} theme${theme} ${
    disabled ? "disabled" : ""
  }`;

  const onReturn = (value) => {
    if (register !== null) {
      onChange(value);
      return setValue(name, value);
    }
    return onChange(value);
  };

  const handleMask = (e) => {
    if (mask === "telefone") return UtilServices.maskPhone(e);
    if (mask === "CPF") return UtilServices.maskCPF(e);
    if (mask === "CNPJ") return UtilServices.maskCNPJ(e);
    if (mask === "Date") return UtilServices.maskDate(e);
    if (mask === "CCM") return UtilServices.maskCCM(e);
    if (mask === "Valores") return UtilServices.maskCurrency(e);
    if (mask === "CNAE") return UtilServices.maskCNAE(e);
    if (mask === "CEP") return UtilServices.maskCEP(e);
    if (mask === "Porcentagem") return UtilServices.maskPercentage(e);
    if (mask === "mesAno") return UtilServices.maskMonthYear(e);
    if (mask === "RG") return UtilServices.maskRG(e);
    if (mask === "Horario") return UtilServices.maskHorario(e);
    if (mask === "Email") return UtilServices.maskEmail(e);
    if (mask === "CaracteresEspeciais")
      return UtilServices.maskRemoveCaracteresEspeciais(e);

    return e;
  };

  const handleChange = (e) => {
    let input = e.target.value;

    if (type === "number") input = input?.replace(/[^0-9]/g, "");
    if (type === "phone") input = input?.replace(/[^0-9+]/g, "");
    if (type === "document") input = input?.replace(/[0-9]/g, "");
    if (type === "login") input = input?.replace(/[^a-zA-Z0-9]/g, "");
    if (type === "password") input = input?.replace(/\s+/g, "");
    if (type === "nomesobrenome")
      input = input?.replace(/[^A-Za-zÀ-Öà-öçÇıİĞğÜüŞş\s]/g, "");
    if (type === "cpfemail") input = input?.replace(/\s+/g, "");

    return onReturn(handleMask(input));
  };

  return (
    <>
      <div className={`input ${className} theme${theme}`}>
        <div style={{ display: "flex" }}>
          {title && <p>{title}</p>}
          {tooltip && (
            <p
              data-tooltip-id={tooltipId}
              data-tooltip-html={tooltipDescricao}
              className="tooltipInput"
              style={{ color: tooltipIconColor, cursor: "pointer" }}
            >
              {tooltipIcon}
            </p>
          )}
        </div>
        {icon && (
          <div className="input-icon">{UtilServices.stringToJsx(icon)}</div>
        )}
        <div
          style={
            dflex
              ? {
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: gapButton,
                }
              : undefined
          }
        >
          <input
            {...(register && {
              ...register(name, {
                ...registerProps,
              }),
            })}
            {...(maxLength !== null && { maxLength })}
            id={id}
            className={inputClassName}
            type={["number", "document", "date"].includes(type) ? "text" : type}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
            style={style}
            defaultValue={defaultValue}
            {...(!register && {
              name,
              value,
            })}
          />
          {button && (
            <ButtonIcon
              {...{
                [iconButton]: true,
                [`title${
                  iconButton.charAt(0).toUpperCase() + iconButton.slice(1)
                }`]: titleButton,
                [`on${
                  iconButton.charAt(0).toUpperCase() + iconButton.slice(1)
                }`]: onClickButton,
                [`type${
                  iconButton.charAt(0).toUpperCase() + iconButton.slice(1)
                }`]: typeButton,
                [`disabled${
                  iconButton.charAt(0).toUpperCase() + iconButton.slice(1)
                }`]: disabledButton,
              }}
            />
          )}
        </div>
      </div>
      {required && errors && errors[name] && (
        <span className="inputMsgError">{errors[name].message}</span>
      )}
    </>
  );
}
